import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NavController, Platform, MenuController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { IfscValidator } from 'src/app/validation/ifsc.validator';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { convertActionBinding } from '@angular/compiler/src/compiler_util/expression_converter';
import * as moment from 'moment';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
    selector: 'app-changedob',
    templateUrl: './changedob.component.html',
    styleUrls: ['./changedob.component.scss'],
})

export class ChangeDOB implements OnInit {
    public changeDobForm: FormGroup;
    currentpath: any;
    applicableTypes: any;
    selectedApplicable: any;
    languageConext: any;
    headingTitle: any;
    file1: any = {};
    file2: any = {};
    TrustFrontImgFile: any;
    TrustBackImgFile: any;
    FrontImgFile: any;
    BackImgFile: any;
    FronImgName: any;
    BackImgName: any;
    FileSelected: any;
    Filearray: any;
    selproof: any;
    agreecheckaadhaaar: boolean = false;
    agreecheck: boolean = false;
    olddob: any;
    newdob: any;
    additionaldocs: any;
    formsubmitted: boolean = false;
    applname: any;
    additionalproofimgs: any = []
    additionalprooftrustimgs: any = [];
    userInfo: any;
    updatedDetails: any;
    normaldropdown: boolean = true;
    nomineedropdown: boolean = false;
    appointeedropdown: boolean = false;
    appointees: any = [];
    nominees: any = [];
    limitedproof: boolean = false;
    additionaldocisempty: boolean = false;
    combineimgary: any = [];
    hidealldetails: boolean = false;


    //added by gokul

    maxDate: any;



    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        private camera: Camera,
        public actionSheetController: ActionSheetController,
        private file: File,
        public api: RestapiService,
        private filePath: FilePath,
        private fileChooser: FileChooser,
        private base64: Base64,
        public actionVal: ActionlistenService,
        public _sanitizer: DomSanitizer,
        public iosfilepicker: IOSFilePicker,
        public cd: ChangeDetectorRef,
        public menuCtrl: MenuController,
        public statusBar: StatusBar) {

        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].changedob;
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].changedob;
        }
        this.headingTitle = this.languageConext.heading.text;
        this.maxDate = moment(new Date()).add('-18', 'years').format('YYYY-MM-DD');

        this.applicableTypes = this.languageConext.nameselect;

        this.changeDobForm = formBuilder.group({
            selectedApplicable: ['', Validators.required],
            applname: ['', Validators.required],
            newdob: ['', Validators.required],
            selproof: ['', Validators.required],
            agreecheckaadhaar: [],
            agreecheck: [],
            additionaldocsvalid: []
        });

        this.cmndeclaration.getstoreProcess('profile').then(data => {
            this.userInfo = data;
            var req = {
                "userSessionID": localStorage.userSessionID,
                "userChatSessionId": localStorage.userChatSessionId,
                "mobileNo": this.userInfo.mobileNo,
                "requestType": "getDOBDetails",
            }
            this.api.postapi("updateDetails", req).then(response => {
                if (response['responseCode'] == '001' || response['responseCode'] == null) {
                    this.updatedDetails = response;
                    this.selectedApplicable = "Policy Owner";
                    this.maxDate = moment(new Date()).add('-18', 'years').format('YYYY-MM-DD');
                    if (this.selectedApplicable == "Policy Owner") {
                        this.hidealldetails = false;
                        this.applname = this.updatedDetails.policyowner.name;
                        this.olddob = this.updatedDetails.policyowner.dob;
                    }

                }

            })
        });
    }

    ionViewWillEnter() {
        this.menuCtrl.swipeEnable(false);
    }

    ngOnInit() {
    }

    removeimgs() {
        if (this.additionaldocs == '' || this.additionaldocs == null || this.additionaldocs == undefined) {
            this.additionalproofimgs = [];
            this.additionalprooftrustimgs = [];
        }
    }

    deleteimg(index) {
        this.additionalprooftrustimgs.splice(index, 1);
        this.additionalproofimgs.splice(index, 1);
    }

    imgs() {
        this.FronImgName = "";
        this.FrontImgFile = "";
        this.BackImgFile = "";
        this.BackImgName = "";
        this.agreecheckaadhaaar = false;
        this.agreecheck = false;
        this.file1 = {};
        this.file2 = {};
        if (this.selproof == "Aadhaar") {
            this.TrustFrontImgFile = 'assets/images/aadhaar.png';
            this.TrustBackImgFile = 'assets/images/aadhaar.png';
        } else if (this.selproof == "Driving License") {
            this.TrustFrontImgFile = 'assets/images/drive.png';
            this.TrustBackImgFile = 'assets/images/driveback.png';
        } else if (this.selproof == "PAN Card") {
            this.TrustFrontImgFile = 'assets/images/panuploadIcon.PNG';
        } else if (this.selproof == "Passport") {
            this.TrustFrontImgFile = 'assets/images/passportfront.jfif';
            this.TrustBackImgFile = 'assets/images/passportback.jpg';
        } else if (this.selproof == "Voter Id") {
            this.TrustFrontImgFile = 'assets/images/voter-id-card.png';
            this.TrustBackImgFile = 'assets/images/voterback.png';
        } else {
            this.TrustFrontImgFile = 'assets/images/other.png';
        }
    }

    pickImage(sourceType, flg) {
        let date = new Date();
        const options: CameraOptions = {
            quality: localStorage.imagequality,
            sourceType: sourceType,
            destinationType: this.camera.DestinationType.DATA_URL,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE
        }
        this.camera.getPicture(options).then(async (imageData) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
            }
            let base64Image = 'data:image/jpeg;base64,' + imageData;
            let stringLength: number = Number(imageData.length);
            let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
            let sizeInMB = sizeInBytes / 1000000;
            if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
                if (imageData.indexOf("file:/") != -1) {
                    this.base64.encodeFile(imageData).then((base64File: string) => {
                        if (flg == "idfront") {
                            this.FronImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
                            this.FrontImgFile = base64File;
                            this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                            this.file1.fileContent = base64File;
                            this.file1.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
                            this.file1.fileContentType = this.selproof;
                        }
                        else if (flg == "idback") {
                            this.BackImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
                            this.BackImgFile = base64File;
                            this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                            this.file2.fileContent = base64File;
                            this.file2.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
                            this.file2.fileContentType = this.selproof;
                        }
                    });
                } else {
                    if (flg == "idfront") {
                        this.FronImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.FrontImgFile = base64Image;
                        this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64Image);
                        this.file1.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.file1.fileContent = base64Image;
                        this.file1.fileContentType = this.selproof;
                    }
                    else if (flg == "idback") {
                        this.BackImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.BackImgFile = base64Image;
                        this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64Image);
                        this.file2.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.file2.fileContent = base64Image;
                        this.file2.fileContentType = this.selproof;
                    }
                }
            } else
                this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");

        }, async(err) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
              }
        });
    }



    async uploadFile(flg: any) {
        this.cmndeclaration.Actionsheetenable = true;
        const actionSheet = await this.actionSheetController.create({
            header: "Select Image source",
            buttons: [{
                text: 'Load from Library',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                    if (this.cmndeclaration.runPlatform == "ios")
                        this.IOSFileselect(flg);
                    else
                        this.Fileselect(flg);
                }
            },
            {
                text: 'Use Camera',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                    this.pickImage(this.camera.PictureSourceType.CAMERA, flg);
                }
            },
            {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                }
            }
            ]
        });
        await actionSheet.present();
    }

    async uploadadditionalproof(flg: any) {
        if (this.additionaldocs == '' || this.additionaldocs == null || this.additionaldocs == undefined) {
            this.additionaldocisempty = true;
        }
        else {
            this.additionaldocisempty = false;
            if (this.additionalproofimgs.length <= 2) {
                this.limitedproof = false;
                this.cmndeclaration.Actionsheetenable = true;
                const actionSheet = await this.actionSheetController.create({
                    header: "Select Image source",
                    buttons: [{
                        text: 'Load from Library',
                        handler: () => {
                            if (this.cmndeclaration.runPlatform == "ios")
                                this.IOSFileselectadditional(flg);
                            else
                                this.Fileselectadditional(flg);
                        }
                    },
                    {
                        text: 'Use Camera',
                        handler: () => {
                            this.cmndeclaration.Actionsheetenable = false;
                            this.pickImageadditional(this.camera.PictureSourceType.CAMERA, flg);
                        }
                    },
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        handler: () => {
                            this.cmndeclaration.Actionsheetenable = false;
                        }
                    }
                    ]
                });
                await actionSheet.present();
            }
            else {
                this.limitedproof = true;
            }
        }

    }

    Fileselectadditional(flg) {
        let stringLength: any;
        let validFormate: any;
        if (this.platform.is('android')) {
            this.fileChooser.open()
                .then(
                    uri => {
                        this.filePath.resolveNativePath(uri)
                            .then(url => {
                                var fileName = url.substring(url.lastIndexOf("/") + 1);
                                validFormate = url.substring(url.lastIndexOf("."), url.length);
                                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                                    this.base64.encodeFile(url).then((base64File: string) => {
                                        if (validFormate.toLowerCase() == ".pdf") {
                                            stringLength = base64File.indexOf("64,") + 3;
                                            base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                                            stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                                        } else
                                            stringLength = base64File.length - 'data:image/png;base64,'.length;

                                        let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                                        let sizeInMB = sizeInBytes / 1000000;
                                        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                                            if (validFormate.toLowerCase() == ".pdf") {
                                                this.additionalprooftrustimgs.push({
                                                    "fileContent": "assets/images/pdfimg.PNG",
                                                    "fileContentName": fileName,
                                                    "fileContentType": this.additionaldocs
                                                })
                                            }
                                            else {
                                                this.additionalprooftrustimgs.push({
                                                    "fileContent": base64File,
                                                    "fileContentName": fileName,
                                                    "fileContentType": this.additionaldocs
                                                })
                                            }
                                            this.additionalproofimgs.push(
                                                {
                                                    "fileContent": base64File,
                                                    "fileContentName": fileName,
                                                    "fileContentType": this.additionaldocs
                                                })
                                        } else {
                                            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                                        }
                                    });
                                } else {
                                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                                }

                            })
                            .catch(err => console.log(err));
                    }
                )
                .catch(error => {
                    console.log(error)
                });
        }
    }

    pickImageadditional(sourceType, flg) {
        let date = new Date();
        const options: CameraOptions = {
            quality: localStorage.imagequality,
            sourceType: sourceType,
            destinationType: this.camera.DestinationType.DATA_URL,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE
        }
        this.camera.getPicture(options).then(async (imageData) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
            }
            let base64Image = 'data:image/jpeg;base64,' + imageData;
            let stringLength: number = Number(imageData.length);
            let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
            let sizeInMB = sizeInBytes / 1000000;
            if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
                if (imageData.indexOf("file:/") != -1) {
                    this.base64.encodeFile(imageData).then((base64File: string) => {
                        this.additionalprooftrustimgs.push({
                            "fileContent": base64File,
                            "fileContentName": imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length),
                            "fileContentType": this.additionaldocs
                        })
                        this.additionalproofimgs.push(
                            {
                                "fileContent": base64File,
                                "fileContentName": imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length),
                                "fileContentType": this.additionaldocs
                            })
                    });
                } else {
                    this.additionalprooftrustimgs.push({
                        "fileContent": base64Image,
                        "fileContentName": "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                        "fileContentType": this.additionaldocs
                    })
                    this.additionalproofimgs.push(
                        {
                            "fileContent": base64Image,
                            "fileContentName": "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            "fileContentType": this.additionaldocs
                        })
                }
            } else
                this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
        }, async(err) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
              }
        });
    }

    Fileselect(flg) {
        let stringLength: any;
        let validFormate: any;
        if (this.platform.is('android')) {
            this.fileChooser.open()
                .then(
                    uri => {
                        this.filePath.resolveNativePath(uri)
                            .then(url => {
                                var fileName = url.substring(url.lastIndexOf("/") + 1);

                                validFormate = url.substring(url.lastIndexOf("."), url.length);
                                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                                    this.base64.encodeFile(url).then((base64File: string) => {
                                        if (validFormate.toLowerCase() == ".pdf") {
                                            stringLength = base64File.indexOf("64,") + 3;
                                            base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                                            stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                                        } else
                                            stringLength = base64File.length - 'data:image/png;base64,'.length;

                                        let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                                        let sizeInMB = sizeInBytes / 1000000;
                                        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                                            if (flg == "idfront") {
                                                this.FronImgName = fileName;
                                                if (validFormate.toLowerCase() == ".pdf") {
                                                    this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                                                }
                                                else {
                                                    this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                                                    this.FrontImgFile = base64File;
                                                }
                                                this.file1.fileContent = base64File;
                                                this.file1.fileContentName = fileName;
                                                this.file1.fileContentType = this.selproof;
                                            }
                                            else if (flg == "idback" && (this.selproof == 'Aadhaar' || this.selproof == 'Driving License' || this.selproof == 'Passport' || this.selproof == 'Voter Id')) {
                                                this.BackImgName = fileName;
                                                if (validFormate.toLowerCase() == ".pdf") {
                                                    this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                                                }
                                                else {
                                                    this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                                                    this.BackImgFile = base64File;
                                                }
                                                this.file2.fileContent = base64File;
                                                this.file2.fileContentName = fileName;
                                                this.file2.fileContentType = this.selproof;
                                            }
                                        } else {
                                            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                                        }
                                    });
                                } else {
                                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                                }

                            })
                            .catch(err => console.log(err));
                    }
                )
                .catch(error => {
                    console.log(error)
                });
        }
    }

    async IOSFileselect(flg) {
        let filePath: any;
        let fileName: any;
        let path: any;
        let validFormate: any;
        let stringLength: any;
        await this.iosfilepicker.pickFile().then(async uri => {
            filePath = "file://" + uri;
            fileName = filePath.split('/').pop();
            path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
            this.file.readAsDataURL(path, fileName).then(base64File => {
                sessionStorage.demo = base64File;
                validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                    stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
                    stringLength = stringLength.length;
                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                        if (flg == "idfront") {
                            this.FronImgName = fileName;
                            if (validFormate.toLowerCase() == ".pdf") {
                                this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                            }
                            else {
                                this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                                this.FrontImgFile = base64File;
                            }
                            this.file1.fileContent = base64File;
                            this.file1.fileContentName = fileName;
                            this.file1.fileContentType = this.selproof;
                        }
                        else if (flg == "idback" && (this.selproof == 'Aadhaar' || this.selproof == 'Driving License' || this.selproof == 'Passport' || this.selproof == 'Voter Id')) {
                            this.BackImgName = fileName;
                            if (validFormate.toLowerCase() == ".pdf") {
                                this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                            }
                            else {
                                this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                                this.BackImgFile = base64File;
                            }
                            this.file2.fileContent = base64File;
                            this.file2.fileContentName = fileName;
                            this.file2.fileContentType = this.selproof;
                        }
                    } else
                        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
                } else
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
            })
                .catch(() => {
                    console.log('Error reading file');
                })
        })
            .catch(err => console.log('Error', err));
    }

    async IOSFileselectadditional(flg) {
        let filePath: any;
        let fileName: any;
        let path: any;
        let validFormate: any;
        let stringLength: any;
        await this.iosfilepicker.pickFile().then(async uri => {
            filePath = "file://" + uri;
            fileName = filePath.split('/').pop();
            path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
            this.file.readAsDataURL(path, fileName).then(base64File => {
                sessionStorage.demo = base64File;
                validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                    stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
                    stringLength = stringLength.length;
                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                        if (validFormate.toLowerCase() == ".pdf") {
                            this.additionalprooftrustimgs.push({
                                "fileContent": "assets/images/pdfimg.PNG",
                                "fileContentName": fileName,
                                "fileContentType": this.additionaldocs
                            })
                        }
                        else {
                            this.additionalprooftrustimgs.push({
                                "fileContent": this._sanitizer.bypassSecurityTrustUrl(base64File),
                                "fileContentName": fileName,
                                "fileContentType": this.additionaldocs
                            })
                        }
                        this.additionalproofimgs.push({
                            "fileContent": base64File,
                            "fileContentName": fileName,
                            "fileContentType": this.additionaldocs
                        })
                    } else
                        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
                } else
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
            })
                .catch(() => {
                    console.log('Error reading file');
                })
        })
            .catch(err => console.log('Error', err));
    }


    async submit() {
        let finalObj: any = [];
        let updatedate = "";
        let array: any = [];
        if (((this.changeDobForm.controls.selectedApplicable.valid == true
            && this.changeDobForm.controls.applname.valid == true
            && this.changeDobForm.controls.newdob.valid == true
            && this.changeDobForm.controls.selproof.valid == true
            && this.selectedApplicable == "Policy Owner") && ((this.selproof == 'Aadhaar' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent") && this.agreecheckaadhaaar) || (this.selproof == 'Driving License' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent")) || (this.selproof == 'PAN Card' && this.file1.hasOwnProperty("fileContent")) || (this.selproof == 'Voter Id' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent")) || (this.selproof == 'Passport' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent"))) && ((this.additionaldocs != '' && this.additionaldocs != null && this.additionaldocs != undefined && this.additionalproofimgs.length > 0) || (this.additionaldocs == '' || this.additionaldocs == null || this.additionaldocs == undefined)))
            || (this.changeDobForm.controls.selectedApplicable.valid == true
                && this.changeDobForm.controls.applname.valid == true
                && this.changeDobForm.controls.newdob.valid == true
                && this.changeDobForm.controls.selproof.valid != true
                && this.selectedApplicable != "Policy Owner")) {
            if (this.olddob == moment(this.newdob).format("DD/MM/YYYY")) {
                this.cmndef.presentAlert('', 'Old Dob and new Dob are same. please select different dob', "doberror");
                return
            }
            this.combineimgary = [];

            if (this.file1.hasOwnProperty("fileContent"))
                this.combineimgary.push(this.file1);
            if (this.file2.hasOwnProperty("fileContent"))
                this.combineimgary.push(this.file2);

            finalObj = this.combineimgary.concat(this.additionalproofimgs);
            if (finalObj.length == 0) {
                finalObj = 'null';
            }
            this.cmndef.loaderstart();

            if (this.cmndeclaration.BrowserBuild == 1)
                updatedate = moment(this.newdob).format("DD/MM/YYYY");
            else
                updatedate = this.newdob;
            var data = {
                "userSessionID": localStorage.userSessionID,
                "userChatSessionID": localStorage.userChatSessionId,
                "actionType": "changeDOB",
                "actionVal": {
                    "applicant": this.selectedApplicable,
                    "applicantName": this.applname,
                    "oldDob": this.olddob,
                    "newDob": updatedate,
                    "actionVal": finalObj
                }
            }
            this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
            await this.api.postapi("akeiraVAAction", data).then(async data => {
                let res = data;
                this.cmndef.loaderend();
                this.cmndeclaration.TamlismaJson = res["chatResp"][0];
                this.changeDobForm.reset();
                sessionStorage.CurrentPage = "/va/chat";
                this.navctrl.navigateForward("/va/chat");
            })
        }
    }

    changeapplicableType(selected) {
        this.selectedApplicable = selected;
        this.agreecheckaadhaaar = false;
        this.agreecheck = false;
        this.newdob = "";
        this.selproof = "";
        this.formsubmitted = false;
        this.file1 = {};
        this.file2 = {};
        this.additionalproofimgs = [];
        this.additionaldocs = '';
        this.additionaldocisempty = false;

        this.changeDobForm.controls.selproof.reset();
        this.changeDobForm.controls.newdob.reset();

        this.cd.detectChanges();
        if (this.selectedApplicable == "Policy Owner") {
            this.hidealldetails = false;
            this.normaldropdown = true;
            this.nomineedropdown = false;
            this.appointeedropdown = false;
            this.applname = this.updatedDetails.policyowner.name;
            this.olddob = this.updatedDetails.policyowner.dob;
            this.maxDate = moment(new Date()).add('-18', 'years').format('YYYY-MM-DD');
        } else if (this.selectedApplicable == "Nominee") {
            this.maxDate = moment(new Date()).format('YYYY-MM-DD');
            if (this.updatedDetails.nominee.length > 0) {
                this.hidealldetails = false;
                this.normaldropdown = false;
                this.nomineedropdown = true;
                this.appointeedropdown = false;
                this.nominees = this.updatedDetails.nominee;
                this.applname = this.updatedDetails.nominee[0].name;
                this.olddob = this.updatedDetails.nominee[0].dob;
            } else if (this.updatedDetails.nominee.name == undefined || this.updatedDetails.nominee.name == '' || this.updatedDetails.nominee.name == 'null') {
                this.hidealldetails = true;
                this.cmndef.presentAlert("", this.languageConext.nomineeage.nomineeempty, "nomineeerror")
            }else if (this.updatedDetails.nominee.name != 'null') {
                this.hidealldetails = false;
                this.normaldropdown = true;
                this.nomineedropdown = false;
                this.appointeedropdown = false;
                this.applname = this.updatedDetails.nominee.name;
                this.olddob = this.updatedDetails.nominee.dob;
            }

        } else if (this.selectedApplicable == "Appointee") {
            this.maxDate = moment(new Date()).add('-18', 'years').format('YYYY-MM-DD');
            if (this.updatedDetails.appointee.length > 0) {
                this.hidealldetails = false;
                this.normaldropdown = false;
                this.nomineedropdown = false;
                this.appointeedropdown = true;
                this.appointees = this.updatedDetails.appointee;
                this.applname = this.updatedDetails.appointee[0].name;
                this.olddob = this.updatedDetails.appointee[0].dob;
            } else if (this.updatedDetails.appointee.name == undefined || this.updatedDetails.appointee.name == '' || this.updatedDetails.appointee.name == 'null') {
                this.hidealldetails = true;
                this.cmndef.presentAlert("", this.languageConext.nomineeage.appointempty, "appointeerror")
            }else if (this.updatedDetails.appointee.name != 'null') {
                this.hidealldetails = false;
                this.normaldropdown = true;
                this.nomineedropdown = false;
                this.appointeedropdown = false;
                this.applname = this.updatedDetails.appointee.name;
                this.olddob = this.updatedDetails.appointee.dob;
            }

        }
    }
    changeapplicant(type, selecttype) {
        if (type == 'nominee') {
            for (var i = 0; i < this.updatedDetails.nominee.length; i++) {
                if (this.updatedDetails.nominee[i].name == selecttype.detail.value) {
                    this.olddob = this.updatedDetails.nominee[i].dob;
                }
            }
        }
        else if (type == 'appointee') {
            for (var i = 0; i < this.updatedDetails.appointee.length; i++) {
                if (this.updatedDetails.appointee[i].name == selecttype.detail.value) {
                    this.olddob = this.updatedDetails.appointee[i].dob;
                }
            }

        }
    }

    //added by gokul

    showDatepicker() {
        var date = new Date().getDate();
        var month = (new Date().getMonth() + 1);
        let fulldate: any;
        if (this.newdob == undefined || this.newdob == null || this.newdob == "") {
            if (this.selectedApplicable == "Nominee") {
                fulldate = new Date('01/01/2001');
                let mdte = new Date();
                this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
                    this.newdob = data;
                    this.changeDateformate();
                }, err => {
                    console.log(err);
                });
            } else {
                var year = moment(new Date()).add('-18', 'years').format('YYYY');
                fulldate = new Date(month + '/' + date + '/' + year);
                let mdte = new Date();
                this.cmndef.showdatePicker(mdte, "", fulldate).then((data: any) => {
                    let dateSplit = String(data).split("/");
                    let demo = dateSplit[2];
                    if (Number(year) < Number(demo))
                        this.newdob = moment(new Date(dateSplit[1] + "/" + dateSplit[0] + "/" + dateSplit[2])).add('-18', 'years').format('DD/MM/YYYY');
                    else
                        this.newdob = data;
                }, err => {
                    console.log(err);
                });
            }

        }
        else {
            let split = this.newdob.split("/");
            let sdate = split[1] + "/" + split[0] + "/" + split[2]
            let d = new Date(sdate);
            if (this.selectedApplicable == "Nominee") {
                fulldate = new Date();
            } else {
                var year = moment(new Date()).add('-18', 'years').format('YYYY')
                fulldate = new Date(month + '/' + date + '/' + year);
            }
            console.log(d);
            this.cmndef.showdatePicker(d, "", fulldate).then(data => {
                this.newdob = data;
                this.changeDateformate();
            }, err => {
                console.log(err);
            });
        }
    }

    changeDateformate() {
        var selectedDate = this.newdob;
        if (this.cmndeclaration.BrowserBuild == 1) {
            selectedDate = selectedDate.substring(0, 10);
            console.log(selectedDate);
            if (selectedDate.indexOf("-") != -1) {
                var splitvar = selectedDate.split("-");
                selectedDate = splitvar[2] + "/" + splitvar[1] + "/" + splitvar[0];
            }
        }
        var mdate = selectedDate.toString();
        var dayThen = parseInt(mdate.substring(0, 2), 10);
        var monthThen = parseInt(mdate.substring(3, 5), 10);
        var yearThen = parseInt(mdate.substring(6, 10), 10);

        if (this.getAge({ year: yearThen, momonthnth: monthThen, day: dayThen }) < 18) {
            this.cmndef.presentAlert("", this.languageConext.nomineeage.label, "alert");
        }
    }

    getAge(date) {
        let curDate = new Date(),
            now = {
                year: curDate.getUTCFullYear(),
                month: curDate.getUTCMonth() + 1,
                day: curDate.getUTCDate()
            },
            diff = now.year % date.year;
        if (now.month < date.month ||
            now.month === date.month && now.day < date.day) {
            diff -= 1;
        }
        return diff;

    }


    changeListener($event, flg): void {
        let fileName: any;
        let validFormate: any;
        let base64File: any;
        let sizeInBytes: any;
        let stringLength: any;
        let sizeInMB: any;
        fileName = $event.target.files[0].name;
        this.FileSelected = flg;
        validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);

        console.log(validFormate);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
            this.cmndef.readThis($event.target).then(data => {
                base64File = data;
                stringLength = base64File.length - base64File.indexOf("64,") + 3;
                sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                sizeInMB = sizeInBytes / 1000000;
                console.log(sizeInMB);
                if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                    if (flg == "idfront") {
                        this.FronImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf") {
                            this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                        }
                        else {
                            this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                            this.FrontImgFile = base64File;
                        }
                        this.file1.fileContent = base64File;
                        this.file1.fileContentName = fileName;
                        this.file1.fileContentType = this.selproof;
                    }
                    else if (flg == "idback" && (this.selproof == 'Aadhaar' || this.selproof == 'Driving License' || this.selproof == 'Passport' || this.selproof == 'Voter Id')) {
                        this.BackImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf") {
                            this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                        }

                        else {
                            this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                            this.BackImgFile = base64File;
                        }
                        this.file2.fileContent = base64File;
                        this.file2.fileContentName = fileName;
                        this.file2.fileContentType = this.selproof;
                    }
                } else {
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                }
            })
        } else {
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
        }
    }


    additionalproofListner($event, flg) {
        let fileName: any;
        let validFormate: any;
        let base64File: any;
        let sizeInBytes: any;
        let stringLength: any;
        let sizeInMB: any;
        fileName = $event.target.files[0].name;
        this.FileSelected = flg;
        validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);

        console.log(validFormate);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
            this.cmndef.readThis($event.target).then(data => {
                base64File = data;
                stringLength = base64File.length - base64File.indexOf("64,") + 3;
                sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                sizeInMB = sizeInBytes / 1000000;
                console.log(sizeInMB);
                if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                    if (validFormate.toLowerCase() == ".pdf") {
                        this.additionalprooftrustimgs.push({
                            "fileContent": "assets/images/pdfimg.PNG",
                            "fileContentName": fileName,
                            "fileContentType": this.additionaldocs
                        })
                    }
                    else {
                        this.additionalprooftrustimgs.push({
                            "fileContent": base64File,
                            "fileContentName": fileName,
                            "fileContentType": this.additionaldocs
                        })
                    }
                    this.additionalproofimgs.push(
                        {
                            "fileContent": base64File,
                            "additionalDocContentName": fileName,
                            "fileContentType": this.additionaldocs
                        })
                } else {
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                }
            })
        } else {
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
        }
    }

    validatefun() {
        this.additionaldocs = this.additionaldocs.replace(/[^A-Za-z0-9!@#$%^&*()-+_.,'"]/g, '');
    }

}